import type { NavigateFunction, To } from 'react-router';

let navigator: NavigateFunction | null = null;

export const setNavigator = (navigateFn: NavigateFunction) => {
  navigator = navigateFn;
};

export const navigate = (to: To, options?: { replace?: boolean; state?: unknown }) => {
  if (!navigator) {
    throw new Error('Navigator has not been initialized');
  }

  navigator(to, options);
};

export const resetNavigator = () => {
  navigator = null;
};
